import * as React from 'react';
import { useState } from 'react';
import { IRecoleccion } from "../../redux/types/recoleccionActionTypes";
import { setRecoleccionDestino, setRecoleccionOrigen } from "../../redux/actions/recoleccionActions";
import { ApplicationState } from "../../redux/reducers";
import { connect } from "react-redux"
import Recoleccion from "./Recoleccion";
import { enums } from "../../enums/enums";
import { setSolicitud, setSolicitudCopia } from "../../redux/actions/solicitudActions";
import { updateServicios } from "../../redux/actions/servicioAdicionalActions";
import { saveTiposEnvio } from "../../redux/actions/tipoEnvioActions";
import { ICliente } from "../../entities/catalogos/ICliente";
import { Solicitud } from "../../entities/solicitudes/Solicitud";
import { IUsuario } from '../../entities/catalogos/IUsuario';
import LoadingDialog from '../controls/LoadingDialog';
import { IHelp } from '../help/Help';
import swal from 'sweetalert2';
import { Add } from '@material-ui/icons';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    createStyles,
    FormControlLabel,
    Grid,
    makeStyles,
    Switch,
    Theme,
    Typography
} from '@material-ui/core';
import { validarDestinoInternacional, validarCruceSolicitud } from "../../blocks/utility";
import useGetInformacionOrigenDestino from "../../hooks/useGetInformacionOrigenDestino";
import { useSnackbar } from "notistack";
import { ServicioAdicional } from "../../entities/catalogos/ServicioAdicional";
import { traducirButton, traducirLabel, traducirMessage } from '../../blocks/traductor';
import ServicioInternacional from '../comercioExterior/ServicioInternacional';
import { CruceInternacional } from '../../entities/catalogos/CruceInternacional';
import NextButton from '../../components/controls/NextButton';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: '100%',
            boxShadow: "none"
        },
        principal: {
            height: '100%',
            backgroundColor: "#fff",
            padding: "10px"
        },

        icon: {
            width: "40px",
            height: "40px",
            minWidth: "40px",
            borderRadius: "20px",
            backgroundColor: "#19754e",
            color: "#fff",
            textAlign: "center",
            paddingTop: "5px"
        },
        title: {
            fontSize: "24px",
            paddingBottom: "20px"
        },
        heading: {
            fontSize: "0.875rem",
            color: "#00653b",
            fontWeight: theme.typography.fontWeightBold,
            borderBottom: "2px solid #00653b"
        },
        headingAdicional: {
            fontSize: theme.typography.pxToRem(20),
            fontWeight: theme.typography.fontWeightBold,
            textAlign: "center"
        },

    }),
);


interface OwnProps {
    siguienteSeccion: (siguienteSeccionId: number, datosSeccion: IRecoleccion, comercioExterior?: any, cruceFronterizo?: any) => void
    setCotizacionID: (cotizacionId: number) => void
    cotizacionId: number
}

interface StateProps {
    cliente: ICliente
    recoleccionOrigen: IRecoleccion
    recoleccionDestino: IRecoleccion
    solicitud: Solicitud
    solicitudCopia: Solicitud
    usuario: IUsuario,
    ayuda: IHelp,
    idiomaId: string
}

interface DispatchProps {
    setRecoleccionOrigen: typeof setRecoleccionOrigen
    setRecoleccionDestino: typeof setRecoleccionDestino
    setSolicitud: typeof setSolicitud
    setSolicitudCopia: typeof setSolicitudCopia
    updateServicios: typeof updateServicios
    saveTiposEnvio: typeof saveTiposEnvio
}

type Props = OwnProps & StateProps & DispatchProps

const OrigenDestino = (props: Props) => {
    const [destinoHabilitado, setDestinoHabilitado] = useState(props.recoleccionOrigen.completado);
    const [comercioExteriorHabilitado, setComercioExteriorHabilitado] = useState(false);
    const [sucursalCruceId, setSucursalCruceId] = useState(props.solicitud.cruceFronterizo?.sucursalId);
    const [cruceFronterizoId, setCruceFronterizoId] = useState(props.solicitud.cruceFronterizo?.cruceInternacionalId);
    const [cruceDescripcion, setCruceFronterizo] = useState(props.solicitud.cruceFronterizo?.cruce);
    const [esInternamientoObligatorio, setEsInternamientoObligatorio] = useState(false);
    const [esInternamiento, setEsInternamiento] = useState(props.solicitud.cruceFronterizo?.esIntraUSA);
    
    const { getTipoServicio, saveServicioAdicionales } = useGetInformacionOrigenDestino(props.cliente,
        props.updateServicios, props.saveTiposEnvio);
    const [showLoading, setLoading] = useState(false);
    const [expanded, setExpanded] = useState<string | false>('Origen');
    const classes = useStyles();
    const { enqueueSnackbar } = useSnackbar();
    const [switched, setSwitched] = useState(false);
    const [sucursalCruceCP, setSucursalCruceCP] = useState(0);

    React.useEffect(() => {
        if (props.solicitud && props.solicitud.id > 0) {
            //Se copia toda la solicitud a solicitud copia para regresar los valores al resumen
            const copiaSolicitud = new Solicitud(props.solicitud);
            copiaSolicitud.tipoSolicitud = "cotizacion";
            props.setSolicitudCopia(copiaSolicitud);

            ///copia recoleccion de la cotizacion pediente
            props.setRecoleccionOrigen(props.recoleccionOrigen);
            props.setRecoleccionDestino(props.recoleccionDestino);
        } else {
            props.setSolicitudCopia(props.solicitud);
            props.setRecoleccionOrigen(props.recoleccionOrigen);
            props.setRecoleccionDestino(props.recoleccionDestino);
            if (!props.recoleccionOrigen.completado) {
                setDestinoHabilitado(false);
            }
        }
        if(props.solicitud && props.solicitud.esHomeDelivery){
            if(props.cliente.esHomeDelivery && props.cliente.tieneConveniosHD)
            setSwitched(props.solicitud.esHomeDelivery);
            else
                setSwitched(false);
        }
        if(props.solicitud && props.solicitud.tipoServicio && props.solicitud.tipoServicio.id !== 3){
            setSwitched(false);
        }

    }, []);

    const siguientePaso = async (recoleccion: IRecoleccion, esOrigen: boolean) => {
        const recoleccionOrigen: IRecoleccion = esOrigen ? recoleccion : props.recoleccionOrigen;
        const recoleccionDestino: IRecoleccion = !esOrigen ? recoleccion : props.recoleccionDestino;

        let copiaSolicitud: Solicitud = new Solicitud({
            ...props.solicitud, tipoSolicitud: "cotizacion",
            estatusId: enums.estatusSolicitud.origenDestino, serviciosAdicionales: []
        });

        await guardarDatos(copiaSolicitud, recoleccionOrigen, recoleccionDestino, esOrigen);
    };

    const guardarDatos = async (copiaSolicitud: Solicitud, recoleccionOrigen: IRecoleccion, recoleccionDestino: IRecoleccion,
        esOrigen: boolean) => {
        if (esOrigen) {
            guardarOrigen(copiaSolicitud, recoleccionOrigen)
        } 
        else{
            const errorServicios = validarServicios(recoleccionOrigen.serviciosAdicionales, recoleccionDestino.serviciosAdicionales);
            if(recoleccionOrigen.eliminaRetornoDocumentos){
                copiaSolicitud.eliminaRetornoDocumentos = true;
            }else{
                copiaSolicitud.eliminaRetornoDocumentos = false;
            }
            const errorCruce = validarDestinoInternacional(recoleccionOrigen, recoleccionDestino);
            if (errorServicios !== "" || errorCruce !== "") {
                if (errorServicios !== "")
                    enqueueSnackbar(errorServicios, { variant: "error" });
                else
                    swal.fire({
                        titleText: traducirMessage(11), // 'Aviso',
                        text: errorCruce,
                        type: 'error'
                    });
                return false
            }
            setLoading(true);

            const serviciosOrigen = recoleccionOrigen.serviciosAdicionales;
            props.setRecoleccionOrigen({ ...recoleccionOrigen, serviciosAdicionales: serviciosOrigen });
            //const obtieneTipoServicio = await getTipoServicio(recoleccionOrigen, recoleccionDestino);
            let resultTipoServicio = await getTipoServicio(recoleccionOrigen, recoleccionDestino);
            copiaSolicitud.tipoServicio = resultTipoServicio;
            copiaSolicitud.tipoServicioReal = resultTipoServicio
            //copiaSolicitud.tipoServicio = obtieneTipoServicio;
            //copiaSolicitud.tipoServicioReal = obtieneTipoServicio;
            if(switched){
                let tipoServicio = {id: 3 , nombre: 'HOME DELIVERY'}
                copiaSolicitud.tipoServicio.id = tipoServicio.id;
                copiaSolicitud.tipoServicio.nombre = tipoServicio.nombre;
                copiaSolicitud.esHomeDelivery = true;
            }
            await saveServicioAdicionales(recoleccionOrigen, recoleccionDestino, copiaSolicitud);
            guardarDestino(copiaSolicitud, recoleccionDestino, !!recoleccionOrigen.esServicioInternacional);

            setLoading(false);
        }
    }

    const handleCruceInternacional = (cruce: CruceInternacional | undefined) => {
        if(cruce != undefined && cruce != null){
            setCruceFronterizoId(cruce.id);
            setSucursalCruceId(cruce.sucursalID);
            setCruceFronterizo(cruce.cruce);
        }
        else{
            setCruceFronterizoId(0);
            setSucursalCruceId(0);
            setCruceFronterizo('');
        }
        setCruceFronterizo(cruce!= undefined && cruce != null ? cruce.cruce : '' ) ;
    }

    const handleIntraUSA = (intraUSA: boolean) => {
        setEsInternamiento(intraUSA);
    }

    const guardarComercioExterior = () =>{
        let comext, cruce, esCruceOrigen;
        let cruceId = cruceFronterizoId ?? 0;
        let sucursalId = sucursalCruceId ?? 0;
        let cruceDescrip = cruceDescripcion ?? '';
        
        if(esInternamiento){//folio 3823
                    swal.fire({
                        titleText: traducirMessage(11),
                        text: traducirMessage(324), // 'El cruce fronterizo no es válido para el servicio Intra USA.',
                        type: 'info'
                    });
        }///fin 3823

        if(cruceId > 0){
            comext = { 
                tipoComercioExteriorId : enums.tipoComercioExterior.internacional
            };
    
            cruce = {
                tipoServicioInternacionalId : 1,
                tipoMovimientoServicioInternacionalId: (props.recoleccionOrigen.esServicioInternacional ? enums.tipoMovimientoServicioInternacional.southbound : enums.tipoMovimientoServicioInternacional.northbound),
                cruceInternacionalId: cruceId,
                esIntraUSA: esInternamiento,
                sucursalCruceId: sucursalId,
                cruce: cruceDescrip
            };

            esCruceOrigen = !!props.recoleccionOrigen.esServicioInternacional;
        }

        let nuevaSolicitud: Solicitud = new Solicitud({
            ...props.solicitudCopia
            , comercioExterior: comext
            , cruceFronterizo: cruce
            , esCruceOrigen: esCruceOrigen
            , esComercioExterior: (comext != undefined)
            , esServicioInternacional: (cruce != undefined)
        });

        const errorCruce = validarCruceSolicitud(props.recoleccionOrigen, props.recoleccionDestino, nuevaSolicitud);
        if (errorCruce !== "") {
            swal.fire({
                        titleText: traducirMessage(11), // 'Aviso',
                        text: errorCruce,
                        type: 'error'
                    });
            return;
        }

        nuevaSolicitud.SetComercioExterior(comext);
        nuevaSolicitud.SetCruceFronterizo(cruce);
        props.setSolicitud(nuevaSolicitud);
        props.setSolicitudCopia(nuevaSolicitud);
        props.siguienteSeccion( enums.estatusSolicitud.datosMercancia, props.recoleccionDestino, comext, cruce);
    }

    const validarServicios = (serviciosOrigen, serviciosDestino): string => {
        const origenSeleccionados = serviciosOrigen.filter(e => e.seleccionado);
        const destinoSeleccionados = serviciosDestino.filter(e => e.seleccionado);
        const origenRequeridos = serviciosOrigen.filter(e => !!e.esRequerido && !e.seleccionado
            && !destinoSeleccionados.some(s => s.id === e.id));
        const destinoRequeridos = serviciosDestino.filter(e => !!e.esRequerido && !e.seleccionado
            && !origenSeleccionados.some(s => s.id === e.id));
        
        const serviciosRequeridos = origenRequeridos.length > 0 || destinoRequeridos.length > 0;
        let retornoDocumentos = serviciosOrigen?.find(e => e.esRetornoDocumentos && e.seleccionado);
        retornoDocumentos = retornoDocumentos || serviciosDestino?.find(e => e.esRetornoDocumentos && e.seleccionado)
        const servicioSinDocumentos = retornoDocumentos != null && !retornoDocumentos?.documentos?.length

        let mensaje = "";
        if (serviciosRequeridos || servicioSinDocumentos) {
            mensaje = serviciosRequeridos ? traducirMessage(126) // "Favor de seleccionar los adicionales requeridos."
                : traducirMessage(98); // "Favor de capturar los retornos de documentos.";
        }

        return mensaje;
    }

    const configurarCruceFronterizo = (recoleccion: IRecoleccion, esOrigen: boolean, copiaSolicitud: Solicitud) => {
        let esCruceOrigen = esOrigen ? (recoleccion.paisId === enums.pais.usa) : !!props.recoleccionOrigen?.esServicioInternacional;
        let esCruceDestino = !esOrigen ? (recoleccion.paisId === enums.pais.usa) : !!props.recoleccionDestino?.esServicioInternacional;
        let esServicioInternacional = (esCruceOrigen || esCruceDestino);

        if(esServicioInternacional){
            let esOrigenSinAreaServicio = esOrigen ? (recoleccion.sinAreaServicio && recoleccion.paisId == 2) : (!!props.recoleccionOrigen?.sinAreaServicio && props.recoleccionOrigen?.paisId == 2);
            let esDestinoSinAreaServicio = !esOrigen ? (recoleccion.sinAreaServicio && recoleccion.paisId == 2) : (!!props.recoleccionDestino?.sinAreaServicio && props.recoleccionDestino?.paisId == 2);
            if(esOrigenSinAreaServicio || esDestinoSinAreaServicio){
                setEsInternamientoObligatorio(true);
                setEsInternamiento(true);    
            }
            else{
                setEsInternamientoObligatorio(false);
            }
                        
            if(expanded == 'Destino'){
                setExpanded('ComercioExterior');
                setComercioExteriorHabilitado(true);
            }
        }
        else{
            setEsInternamiento(false);
            setEsInternamientoObligatorio(false);
            let nuevaSolicitud: Solicitud = new Solicitud({...copiaSolicitud});
            nuevaSolicitud.SetComercioExterior(null);
            nuevaSolicitud.SetCruceFronterizo(null);
            props.setSolicitud(nuevaSolicitud);
            props.setSolicitudCopia(nuevaSolicitud);
        }
    }

    const validaIntraSucursalCruceSucursal = ()=>{
        let areaServicioOrigen = props.recoleccionOrigen?.areaServicio?.id ?? 0;
        let areaServicioDestino = props.recoleccionDestino?.areaServicio?.id ?? 0;
        let sucursalCruceIdV = sucursalCruceId ?? 0;
        let sucursalOrigenCP = props.recoleccionOrigen?.sucursal?.id ?? 0;
        let sucursalDestinoCP = props.recoleccionDestino?.sucursal?.id ?? 0;

        if((areaServicioOrigen!=0 && props.recoleccionOrigen.paisId == 2) && sucursalCruceIdV != sucursalOrigenCP){
            setEsInternamientoObligatorio(false);
            setEsInternamiento(false);    
        }

        if((areaServicioDestino!=0 && props.recoleccionDestino.paisId == 2) && sucursalCruceIdV != sucursalDestinoCP){
            setEsInternamientoObligatorio(false);
            setEsInternamiento(false);
        }

        if((areaServicioOrigen == 0 && props.recoleccionOrigen.paisId == 2) && sucursalCruceIdV != sucursalOrigenCP){
            setEsInternamientoObligatorio(true);
            setEsInternamiento(true);
        }

        if((areaServicioDestino == 0 && props.recoleccionDestino.paisId == 2) && sucursalCruceIdV != sucursalDestinoCP){
            setEsInternamientoObligatorio(true);
            setEsInternamiento(true);
        }

        if((areaServicioOrigen!=0 && props.recoleccionOrigen.paisId == 2) && sucursalCruceIdV === sucursalOrigenCP){
            setEsInternamientoObligatorio(false);
           setEsInternamiento(false);
        }

        if((areaServicioDestino!=0 && props.recoleccionDestino.paisId == 2) && sucursalCruceIdV === sucursalDestinoCP){
            setEsInternamientoObligatorio(false);
            setEsInternamiento(false);
        }
        //4233

        if(areaServicioOrigen!=0 && props.recoleccionOrigen.paisId == 2){   
            setSucursalCruceCP(sucursalOrigenCP);
        }

        if(areaServicioDestino!=0 && props.recoleccionDestino.paisId == 2){
            setSucursalCruceCP(sucursalDestinoCP);
        }

        if(areaServicioOrigen == 0 && props.recoleccionOrigen.paisId == 2){
            setSucursalCruceCP(0);
        }

        if(areaServicioDestino == 0 && props.recoleccionDestino.paisId == 2){
            setSucursalCruceCP(0);
        }

        if(areaServicioOrigen!=0 && props.recoleccionOrigen.paisId == 2){
           setSucursalCruceCP(sucursalOrigenCP);
        }

        if(areaServicioDestino!=0 && props.recoleccionDestino.paisId == 2){
            setSucursalCruceCP(sucursalDestinoCP);
        }
    }


    const guardarOrigen = (copiaSolicitud: Solicitud, recoleccion: IRecoleccion) => {    
        setExpanded('Destino');
        setDestinoHabilitado(true);   
        configurarCruceFronterizo(recoleccion, true, copiaSolicitud);

        //Guarda los valores de la recolección de origén en la solicitud original
        copiaSolicitud.SetOrigen(recoleccion);
        props.setRecoleccionOrigen(recoleccion);
        props.setSolicitud(copiaSolicitud);
        props.setSolicitudCopia(copiaSolicitud);
    }

    const guardarDestino = (copiaSolicitud: Solicitud, recoleccion: IRecoleccion, cruceEnOrigen: boolean) => {
        const test: any = [];
        recoleccion.serviciosAdicionales?.forEach(e => {
            const nuevoServicio = new ServicioAdicional(e);
            nuevoServicio.seleccionado = cruceEnOrigen && e.nombre.includes("FLETE CRUCE FRONTERIZO") ? false : e.seleccionado;
            test.push(nuevoServicio);
        })
        const serviciosDestino = cruceEnOrigen ?
            recoleccion.serviciosAdicionales?.filter(e => !e.nombre.includes("FLETE CRUCE FRONTERIZO"))
            : recoleccion.serviciosAdicionales;
        const copiaRecoleccionDestino = { ...recoleccion, serviciosAdicionales: test };
        if(switched){
            recoleccion.esHomeDelivery = true;
            copiaSolicitud.esHomeDelivery = true;
            copiaRecoleccionDestino.esHomeDelivery = true;
        }
        if(!switched){
            recoleccion.esHomeDelivery = false;
            copiaSolicitud.esHomeDelivery = false;
            copiaRecoleccionDestino.esHomeDelivery = false;
        }

        copiaSolicitud.SetDestino(recoleccion);        
        props.setRecoleccionDestino(copiaRecoleccionDestino);
        props.setSolicitud(copiaSolicitud);
        props.setSolicitudCopia(copiaSolicitud);
        configurarCruceFronterizo(recoleccion, false, copiaSolicitud);
        
        if(expanded == 'Destino' && !cruceEnOrigen && !recoleccion.esServicioInternacional){
            props.siguienteSeccion(enums.estatusSolicitud.datosMercancia, copiaRecoleccionDestino);
        }
    }

    const handleChangePanel = (panel: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
        setExpanded(isExpanded ? panel : false);
    };

    const handleChangePanelDestino = (panel: string) => {
        if (expanded === panel) setExpanded(false);
        else setExpanded(panel);
    };

    const handleSwitchHD = () => {
        setSwitched(!switched);
    }

    const actualizarIdioma = (idiomaId: string) => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
          }, 1000);
        
    }

    React.useEffect(() => {
        validaIntraSucursalCruceSucursal();
        }, [
            sucursalCruceId, 
            props.recoleccionOrigen?.areaServicio?.id, 
            props.recoleccionDestino?.areaServicio?.id,
            props.recoleccionOrigen?.sucursal?.id,
            props.recoleccionDestino?.sucursal?.id,
            esInternamientoObligatorio
    ]);

    return (<>
        <Accordion expanded={expanded === 'Origen'} onChange={handleChangePanel('Origen')}>
            <AccordionSummary
                expandIcon={<Add />}
                aria-controls="panel1a-content"
                id="panel1a-header">
                <Typography component={'span'} className={classes.heading}>
                    {/* ORIGEN */
                        traducirLabel(222)}
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container spacing={1}>
                    <Grid item sm={12}>
                        <div>
                            <Recoleccion changeIdioma={actualizarIdioma} esOrigen={true} value={props.recoleccionOrigen} siguientePaso={siguientePaso}
                                cotizacionId={props.cotizacionId} />
                        </div>
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
        {( props.cliente.esHomeDelivery && props.cliente.tieneConveniosHD &&
        <Accordion expanded={expanded === 'Destino'} >
            
                <AccordionSummary disabled={!destinoHabilitado}
                    //expandIcon={<Add />}
                    expandIcon={
                        <Add
                        onClick={() => {
                            handleChangePanelDestino('Destino')
                        }}
                        style={{ cursor: "pointer" }}
                        />
                    }
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                >
                    <Grid item sm={9} onClick={() => { handleChangePanelDestino('Destino') }}>
                    <Typography component={'span'} className={classes.heading}>
                        {/* DESTINATARIO */
                            traducirLabel(85)}
                    </Typography>
                    </Grid>
                    <Grid item sm={3}>
                    <FormControlLabel
                                checked={switched}
                                control={<Switch color="primary" />}
                                label={traducirLabel(342)}
                                onChange={handleSwitchHD}
                            />
                    </Grid>
                    
                </AccordionSummary>
                  
            
            <AccordionDetails>
                <Grid container spacing={1}>
                    <Grid item sm={12}>
                        <Recoleccion esOrigen={false} value={props.recoleccionDestino} siguientePaso={siguientePaso}
                            cotizacionId={props.cotizacionId} />
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
        )}
        
        { (!props.cliente.esHomeDelivery || !props.cliente.tieneConveniosHD) &&
        <Accordion expanded={expanded === 'Destino'} onChange={handleChangePanel('Destino')}>
            
            <AccordionSummary disabled={!destinoHabilitado}
                expandIcon={<Add />}
                aria-controls="panel2a-content"
                id="panel2a-header"
            >
                <Typography component={'span'} className={classes.heading}>
                    {/* DESTINATARIO */
                        traducirLabel(85)}
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container spacing={1}>
                    <Grid item sm={12}>
                        <Recoleccion esOrigen={false} value={props.recoleccionDestino} siguientePaso={siguientePaso}
                            cotizacionId={props.cotizacionId} />
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
        }

        {(props.recoleccionOrigen.esServicioInternacional || props.recoleccionDestino.esServicioInternacional) &&
            <Accordion expanded={expanded === 'ComercioExterior'} onChange={handleChangePanel('ComercioExterior')}>
                
                <AccordionSummary disabled={!comercioExteriorHabilitado}
                    expandIcon={<Add />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                >
                    <Typography component={'span'} className={classes.heading}>
                        {/* Comercio Exterior */
                            traducirLabel(344)}
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container spacing={1}>
                        <Grid item sm={12}>
                            <ServicioInternacional tieneCruceFronterizo={true} esInternamientoObligatorio={esInternamientoObligatorio} 
                                onSelectCruce={handleCruceInternacional} 
                                onClickIntraUSA={handleIntraUSA}
                                cruceInicialId={props.solicitud?.cruceFronterizo?.cruceInternacionalId}
                                intraUSAInicial={props.solicitud?.cruceFronterizo?.esIntraUSA}
                                sucursalId={sucursalCruceCP}
                                />
                            <NextButton nextStep={guardarComercioExterior} />
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>
            
        }

        {showLoading &&
            // Procesando
            <> <LoadingDialog titulo={traducirLabel(240)} abierto={true} /></>
        }

    </>)
};

const mapStateToProps = (state: ApplicationState) => ({
    cliente: state.cliente,
    recoleccionOrigen: state.recoleccionOrigen,
    recoleccionDestino: state.recoleccionDestino,
    solicitud: state.solicitud,
    solicitudCopia: state.solicitudCopia,
    usuario: state.usuario,
    ayuda: state.ayuda,
    idiomaId: state.idioma
});

const mapDispatchToProps = {
    setRecoleccionOrigen: setRecoleccionOrigen,
    setRecoleccionDestino: setRecoleccionDestino,
    setSolicitud: setSolicitud,
    setSolicitudCopia: setSolicitudCopia,
    updateServicios: updateServicios,
    saveTiposEnvio: saveTiposEnvio,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrigenDestino);
